import api from './api';

// ── Types ─────────────────────────────────────────────────────────────────────

export interface WineDisplaySnapshot {
  name:          string;
  displayVintage:string;
  producerName:  string | null;
  color:         string | null;
}

export interface OrphanedItemCandidate {
  wineId:        string;
  name:          string;
  vintageType:   string;
  displayVintage:string;
}

export interface OrphanedItem {
  id:                 string;
  venueId:            string;
  locationId:         string | null;
  bottleSize:         number | null;
  wineDisplay:        WineDisplaySnapshot | null;
  inactiveWine: {
    id:   string;
    name: string;
  };
  balance:            number;
  movementCount:      number;
  candidates:         OrphanedItemCandidate[];
  candidatesExcluded: number;
  createdAt:          string;
}

export interface OrphanedItemsResponse {
  data:       OrphanedItem[];
  pagination: { page: number; limit: number; totalItems: number; totalPages: number };
}

export interface InventoryItemCandidate {
  inventoryItemId: string;
  locationId:      string | null;
  bottleSize:      number | null;
  wineDisplay:     WineDisplaySnapshot | null;
}

export interface UnlinkedWli {
  id:              string;
  wineListId:      string;
  wineId:          string;
  wineDisplay:     WineDisplaySnapshot | null;
  inventoryItemId: string | null;
  bottleSize:      number | null;
  listPrice:       number | null;
  currency:        string | null;
  candidates:      InventoryItemCandidate[];
  createdAt:       string;
}

export interface UnlinkedWlisResponse {
  data:       UnlinkedWli[];
  pagination: { page: number; limit: number; totalItems: number; totalPages: number };
}

// ── Service ───────────────────────────────────────────────────────────────────

const BASE = '/admin/governance/repair';

const repairService = {
  // Orphaned InventoryItems
  getOrphanedItems: async (page = 1, limit = 50): Promise<OrphanedItemsResponse> => {
    const res = await api.get<OrphanedItemsResponse>(`${BASE}/orphaned-items`, { params: { page, limit } });
    return res.data;
  },

  relinkOrphanedItem: async (itemId: string, targetWineId: string): Promise<void> => {
    await api.post(`${BASE}/orphaned-items/${itemId}/relink`, { targetWineId });
  },

  deactivateOrphanedItem: async (itemId: string): Promise<void> => {
    await api.post(`${BASE}/orphaned-items/${itemId}/deactivate`);
  },

  // Unlinked WineListItems
  getUnlinkedWlis: async (venueId: string, page = 1, limit = 50): Promise<UnlinkedWlisResponse> => {
    const res = await api.get<UnlinkedWlisResponse>(`${BASE}/unlinked-wlis`, { params: { venueId, page, limit } });
    return res.data;
  },

  linkWli: async (wliId: string, inventoryItemId: string): Promise<void> => {
    await api.post(`${BASE}/unlinked-wlis/${wliId}/link`, { inventoryItemId });
  },
};

export default repairService;
